import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const navigationItems = [
    { name: 'Sites de Paris', href: '/sites-paris' },
    { name: 'Bonus', href: '/bonus' },
    { name: 'Pronostics', href: '/pronostics' },
    { name: 'Guides', href: '/guides' }
  ];

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/9643cc96-b86f-4efa-8d80-b37b546d9b1f/images/2fd5ab3b44fa3f4907d93728c24de30513411ee13e80ef5a6d9f68b4b7962ca6.png" 
              alt="123Pariez"
              className="h-16 md:h-20"
            />
          </Link>

          {/* Navigation - Desktop only */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* 18+ Badge */}
          <div className="flex items-center space-x-3">
            <span className="bg-red-600 text-white text-sm px-3 py-1.5 rounded font-bold">18+</span>
            <span className="hidden sm:inline text-sm text-gray-500">Jeu responsable</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;